<template>
    <div class="apprentice-simple-card dashboard-calendar">
        <div class="component-title">
            <h5 class="title">{{ $t('dashboard.appointments') }}</h5>
            <b-button
                class="btn-show-all btn-link-type"
                variant="primary"
                @click.prevent.stop()="showCalendar">
                Agenda
            </b-button>
        </div>

        <div
            class="apprentice-appointments-widget appointments-list"
            v-if="getCurrentMonthItems.length">
            <div
                class="appointment-item"
                v-for="agendaItem in getCurrentMonthItems"
                :key="agendaItem.id">
                <div
                    class="header"
                    @click="redirect(agendaItem)">
                    <div class="title">{{ agendaItem.title ? agendaItem.title.trim() : 'Geen titel' }}</div>
                    <div
                        class="type"
                        :class="agendaItem.type ? `text-${agendaItem.type.class}` : 'text-warning'">
                        <i
                            class="fas fa-fw"
                            :class="getIconType(agendaItem)"></i>
                    </div>
                </div>
                <div class="date">
                    {{ agendaItem.date | date_named_month_short }}
                </div>
            </div>
        </div>

        <div
            class="empty-appointments-list"
            v-else>
            <b-alert
                show
                variant="info"
                >{{ $t('dashboard.no_appointments_found') }}</b-alert
            >

            {{ $t('slu_dashboard.no_modules_found_for_the_chosen_school_year') }}.
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-dashboard-calendar-widget-component',
    props: {
        agendaItemsIn: Array,
    },
    computed: {
        getCurrentMonthItems() {
            const currentDay = this.moment().format('YYYY-MM-DD');
            const upCommingEvents = this.agendaItemsIn.filter((item) => {
                if (this.moment(item.date).diff(currentDay) >= 0 || this.moment(item.date_end).diff(currentDay) >= 0) {
                    return item;
                }
            });

            if (upCommingEvents.length) {
                return upCommingEvents.slice(0, 3);
            }

            return [];
        },
    },
    methods: {
        redirect(agendaItem) {
            if (agendaItem.url) {
                window.location.href = agendaItem.url;
            } else {
                this.showCalendar();
            }
        },

        showCalendar() {
            window.location.href = this.routes.baseUrl() + '/calendar';
        },

        getCurrentMonth(shortMonth) {
            if (shortMonth.endsWith('.')) {
                return shortMonth.slice(0, -1);
            }

            return shortMonth;
        },

        getIconType(item) {
            if (item.type) {
                if (item.type.name.toLocaleLowerCase() === 'deadline') {
                    return 'fa-alarm-exclamation';
                }
            }

            return 'fa-calendar-day';
        },
    },
};
</script>

<style scoped lang="scss">
.header {
    &:hover {
        cursor: pointer;
    }
}

.dashboard-calendar-card {
    border: none;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
    margin-bottom: 0;

    .dashboard-calendar-card-header {
        border: none;
        background-color: transparent;

        .title {
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }

    .dashboard-calendar-card-body {
        padding: 0;
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .dashboard-calendar-card {
        .component-title {
            flex-direction: column;

            .title,
            .btn {
                margin-right: 0;
            }

            .btn {
                align-self: flex-end;
            }
        }
    }

    .sidebar-menu.collapse:not(.show) + .main-content {
        .dashboard-sidebar {
            .component-title {
                flex-direction: row;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .dashboard-calendar-card {
        .component-title {
            flex-direction: row;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .dashboard-calendar-card {
        max-width: 450px;
        width: 100%;
        align-self: center;
    }
}
</style>
